
import {Component, Input, OnInit} from '@angular/core';
import {DeviceSlot} from "../../types/devices/device-slot";


@Component({
  selector: 'wm-slot-info',
  templateUrl: './slot-info.component.html',
  styleUrls: ['./slot-info.component.less'],
})

/* a generic Information Component that displays DeviceSlots. Supports no operations, this is a Container only. */
export class SlotInfoComponent {

  @Input() slot: DeviceSlot;
  @Input() cursorPointer: boolean = false;
  @Input() showType: boolean = false;

  getSlotTypeLabel(): string {
    if (this.slot.isPublicSlot()) {
      return 'Public mobile device slot';
    }
    if (this.slot.isVCloudSlot() && this.slot.isWindowsSlot()) {
      return this.slot.isCustomSlot() ? 'Custom Windows virtual machine slot' : 'Windows virtual machine slot';
    }
    if (this.slot.isVCloudSlot() && this.slot.isMacOSSlot()) {
      return this.slot.isCustomSlot() ? 'Custom macOS virtual machine slot' : 'macOS virtual machine slot';
    }
    if (this.slot.isVCloudSlot()) {
      return this.slot.isCustomSlot() ? 'Custom virtual machine slot' : 'Virtual machine slot';
    }
    if (this.slot.isPrivateSlot()) {
      return 'Private mobile device slot';
    }
    if (this.slot.isHeadlessSlot()) {
      return 'Headless device slot';
    }
    return 'Device slot';
  }
}
